<div class="flex flex-col w-full items-center relative">
  <span class="icon-Close_round_ico absolute top-[20px] right-[20px] text-black-light cursor-pointer" (click)="close()"></span>
  <img class="absolute top-[20px] left-[20px]" ngSrc="assets/img/mittanbud/mittanbud-title.svg" height="32" width="147" />

  <div class="bg-n6-pipes flex w-full rounded-t-[20px]">
    <img [ngSrc]="'assets/img/mittanbud/mitanbud-image-cropped.webp'" height="500" width="800" class="w-full h-[45vh] object-contain" />
  </div>


  <div class="flex flex-col gap-[20px] pt-[15px] pb-[25px] px-[76px]">
    <h1 class="text-[4vh] font-magnet-bold leading-[5vh] flex justify-center text-b2-dark-brick text-center">
      {{ mainTitle | translate }}
    </h1>
    <p class="text-b2-dark-brick text-[2.5vh] leading-[3vh] font-magnet-bold flex justify-start">
      {{ subTitle | translate }}
    </p>

    <div class="flex flex-col gap-[10px]">
      @for (info of jobStats; track $index) {
        <div class="flex items-center gap-[5px] text-[1.8vh] leading-[3vh]">
          <span [class]="info.icon"></span>
          <span>{{ info.key | translate }}</span>
        </div>
      }
    </div>

    <div
      (click)="getContact()"
      class="uppercase relative min-h-[36px] rounded-[4px] cursor-pointer bg-b1-poppy-hammer mx-auto text-12 leading-[16px] font-[500] w-[261px] h-[36px] text-white border border-orange-btn-border flex justify-center items-center">
      <loader class="white-loader absolute left-[15px] top-[10%]" [loading]="mittanbud.mittanbudEntity.loading$ | push" [small]="true"></loader>
      <span>{{ getContacted | translate }}</span>
    </div>
  </div>
</div>
